import { createContext, useContext } from 'react';

export const FrameContext = createContext();
export const useFrame = () => useContext(FrameContext);
